module.exports = __webpack_public_path__ + "img/forward.df1398fd.svg";